import { useQuery } from '@apollo/client';
import { GET_ME } from '../queries/getMe';

/**
 * Does this person belong to more than one organisation?
 *
 * Which is the same question as "is there anything to switch between" — the switcher is hidden
 * for the large majority who belong to one, because an entry that always leads to a page with a
 * single option is noise.
 *
 * Reads `GET_ME`, which every other role hook already reads, so this costs no extra request: the
 * Apollo cache answers it.
 */
export const useHasMultipleOrganisations = (): boolean => {
  const { data, loading, error } = useQuery(GET_ME);
  if (loading || error) return false;
  return (data?.me?.organisations?.length ?? 0) > 1;
};
